import { ApisErrorType, OptionCheckbox } from './ApisForm.model';

export enum ApisConstants {
	VISA = 'VISA',
	PASSPORT = 'PSPT'
}

export type RequiredFieldsType = (
	| PersonalDataFields
	| AdditionalInfoFields
	| DocMandatoryFields
	| PassengerAddressFields
	| EmergencyInfoFields
	| InfantFields
	| CheckboxInfoFieldsRequired
)[];

export enum PersonalDataFields {
	NAME = 'personalData.name',
	SURNAME = 'personalData.surname',
	BIRTHDATE = 'personalData.birthDate',
	NATIONALITY = 'personalData.nationality',
	COUNTRY = 'personalData.country',
	GENDER = 'personalData.gender'
}

export enum AdditionalInfoFields {
	EMAIL = 'contactData.additionalInfo.email',
	PHONE = 'contactData.additionalInfo.phone',
	NUMBER = 'contactData.additionalInfo.number',
	USE_ALL = 'contactData.additionalInfo.checkInfoAll',
	MODEL = 'contactData.additionalInfo'
}

export enum EmergencyInfoFields {
	NAME = 'contactData.emergencyInfo.name',
	PHONE = 'contactData.emergencyInfo.phone',
	NUMBER = 'contactData.emergencyInfo.number',
	USE_ALL = 'contactData.emergencyInfo.checkEmergencyAll',
	MODEL = 'contactData.emergencyInfo'
}

export enum DocMandatoryFields {
	EXPIRY_DATE = 'documentationRequired.mandatory.expiryDate',
	TYPE = 'documentationRequired.mandatory.type',
	NUMBER = 'documentationRequired.mandatory.number',
	ISSUER_COUNTRY = 'documentationRequired.mandatory.issuerCountry'
}

export enum DocOtherFields {
	MODEL = 'documentationRequired.other',
	EXPIRY_DATE = 'documentationRequired.other.expiryDate',
	TYPE = 'documentationRequired.other.type',
	NUMBER = 'documentationRequired.other.number',
	ISSUER_COUNTRY = 'documentationRequired.other.issuerCountry'
}

export enum DocVisaFields {
	MODEL = 'documentationRequired.visa',
	EXPIRY_DATE = 'documentationRequired.visa.expiryDate',
	TYPE = 'documentationRequired.visa.type',
	NUMBER = 'documentationRequired.visa.number',
	ISSUER_COUNTRY = 'documentationRequired.visa.issuerCountry'
}

export enum DocVisaFieldsInfant {
	MODEL = 'infant.documentationRequired.visa',
	EXPIRY_DATE = 'infant.documentationRequired.visa.expiryDate',
	TYPE = 'infant.documentationRequired.visa.type',
	NUMBER = 'infant.documentationRequired.visa.number',
	ISSUER_COUNTRY = 'infant.documentationRequired.visa.issuerCountry'
}

export enum PassengerAddressFields {
	STATE = 'passengerAddress.state',
	CITY = 'passengerAddress.city',
	ZIP_CODE = 'passengerAddress.zipCode',
	ADDRESS = 'passengerAddress.address',
	USE_ALL = 'passengerAddress.checkAddressForAll',
	MODEL = 'passengerAddress'
}

export enum InfantFields {
	NAME = 'infant.personalData.name',
	SURNAME = 'infant.personalData.surname',
	BIRTHDATE = 'infant.personalData.birthDate',
	NATIONALITY = 'infant.personalData.nationality',
	COUNTRY = 'infant.personalData.country',
	GENDER = 'infant.personalData.gender',
	EXPIRY_DATE = 'infant.documentationRequired.mandatory.expiryDate',
	NUMBER = 'infant.documentationRequired.mandatory.number',
	ISSUER_COUNTRY = 'infant.documentationRequired.mandatory.issuerCountry'
}

export enum CheckboxInfoFieldsRequired {
	US_PRIVACY_EMERGENCY_DATA = 'checkbox.usPrivacyEmergencyData',
	CONFIRM_EMERGENCY_DATA = 'checkbox.confirmEmergencyData'
}

export enum CheckboxInfoFields {
	NOT_SEND_NEWSLETTER = 'checkbox.notSendNewsletter',
	US_PRIVACY_EMERGENCY_DATA = 'checkbox.usPrivacyEmergencyData',
	CONFIRM_EMERGENCY_DATA = 'checkbox.confirmEmergencyData'
}

export const dataCheckBoxPrivacyStatement: OptionCheckbox[] = [
	{
		name: CheckboxInfoFields.US_PRIVACY_EMERGENCY_DATA,
		label: 'CHECK_US_PRIVACY_ACT_STATEMENT',
		className: 'box_Checkbox',
		required: true,
		i18nTrans: true
	}
];
export const dataCheckBoxInfo: OptionCheckbox[] = [
	{
		name: CheckboxInfoFields.CONFIRM_EMERGENCY_DATA,
		label: 'CHECK_CONFIRM_INFORMATION_PROVIDED',
		className: 'box_Checkbox',
		required: true
	},
	{
		name: CheckboxInfoFields.NOT_SEND_NEWSLETTER,
		label: 'NOT_SEND_NEWSLETTER',
		className: 'box_Checkbox',
		required: false,
		i18nTrans: true
	}
];

export enum ApisError {
	TM_VISA_REQUIRED = 'TM_VISA_REQUIRED',
	TM_PSPT_VALIDITY = 'TM_PSPT_VALIDITY',
	PSPT_VALIDITY_3_MONTHS = 'PSPT_VALIDITY_3_MONTHS',
	PSPT_VALIDITY_6_MONTHS = 'PSPT_VALIDITY_6_MONTHS',
	API_DOCUMENT_EXPIRY_DATE = 'API_DOCUMENT_EXPIRY_DATE'
}

export const errorKeyMapping = {
	TM_VISA_REQUIRED: {
		translationKey: 'MISSING_FIELDS_VISA',
		linkPath: 'visa'
	},
	TM_PSPT_VALIDITY: {
		translationKey: 'INVALID_EXPIRY_DATE',
		linkPath: 'documentation-required'
	},
	API_DOCUMENT_EXPIRY_DATE: {
		translationKey: 'INVALID_EXPIRY_DATE',
		linkPath: 'documentation-required'
	},
	PSPT_VALIDITY_3_MONTHS: {
		translationKey: 'INVALID_EXPIRY_DATE',
		linkPath: 'documentation-required'
	},
	PSPT_VALIDITY_6_MONTHS: {
		translationKey: 'INVALID_EXPIRY_DATE',
		linkPath: 'documentation-required'
	}
};

export const errorApisTypes: ApisErrorType[] = [
	//'TM_ESTA_REQUIRED',
	//'TM_VISA_OPTIONAL',
	//'TM_RETURN_TICKET_REQUIRED',
	//'TM_TRAVEL_DOC_REQUIRED',
	'TM_VISA_REQUIRED',
	'TM_PSPT_VALIDITY',
	'PSPT_VALIDITY_3_MONTHS',
	'PSPT_VALIDITY_6_MONTHS',
	'API_DOCUMENT_EXPIRY_DATE'
];
